// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-menu-closed .pane.jobs-pane .new-job-backdrop {
  top: 7rem;
  left: 0;
}
.pane.jobs-pane {
  width: calc(100vw - 14rem);
}
.pane.jobs-pane .show-new-job-toggle {
  position: relative;
  top: -3rem;
  left: 17rem;
}
.pane.jobs-pane .action-bar:has(.cancel-many :checked) .show-new-job-toggle {
  left: 45rem;
}
.pane.jobs-pane .new-job-backdrop {
  align-items: center;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  position: fixed;
  top: 4rem;
  right: 0;
  bottom: 0;
  left: 13rem;
  z-index: 999;
}
.pane.jobs-pane .new-job-editor-area {
  background-color: var(--color-base-canvas-translucent);
  border: var(--border-elevated);
  color: var(--color-elevated-text);
  line-height: 1.3rem;
  margin-top: -6rem;
  margin-left: -3rem;
  padding: 0;
  text-align: right;
  height: calc(100% - 16rem);
  width: calc(100% - 14rem);
  z-index: 1000;
}
.pane.jobs-pane .new-job-container.hidden {
  display: none;
}
.pane.jobs-pane .new-job-container .error-display {
  position: absolute;
  top: 60%;
  left: 50%;
  margin-left: -10rem;
  width: 20rem;
  z-index: 2000;
  background-color: var(--color-elevated-canvas);
  border: 1px solid var(--color-elevated-warn);
  padding: 1rem 2rem;
}
.pane.jobs-pane .new-job-cancel {
  margin-right: 3rem;
  position: relative;
  top: 1rem;
  right: -3rem;
  width: 4rem;
}
.pane.jobs-pane .new-job-submit {
  position: relative;
  top: 1rem;
  right: -3rem;
  width: 12rem;
}
.pane.jobs-pane .new-job-editor {
  height: 100%;
  width: 100%;
  line-height: 1.7rem;
  margin: 0;
  padding: 1.5rem;
  font-size: 1rem;
  font-family: ui-monospace, Menlo, Monaco, "Cascadia Mono", "Segoe UI Mono", "Roboto Mono", "Oxygen Mono", "Ubuntu Mono", "Source Code Pro", "Fira Mono", "Droid Sans Mono", "Consolas", "Courier New", monospace;
}
.pane.jobs-pane .cancel-many, .pane.jobs-pane .jobs-list, .pane.jobs-pane .search-reminder {
  flex-shrink: 1;
}
.pane.jobs-pane .jobs-grid {
  display: grid;
  grid-auto-rows: max-content;
  grid-template-columns: minmax(15rem, auto) 9rem 17rem 17rem;
  column-gap: 2rem;
}
.pane.jobs-pane .job-details-column.operations {
  display: grid;
  grid-column: span 3;
  grid-template-columns: subgrid;
}
.pane.jobs-pane .jobs-grid.show-creator-in-summary {
  grid-template-columns: minmax(15rem, auto) 9rem 9rem 17rem 17rem;
}
.pane.jobs-pane .jobs-grid.show-creator-in-summary .job-details-column.main-action {
  grid-column: span 2;
}
.pane.jobs-pane .job-operations-column.history {
  grid-column: span 2;
}
.pane.jobs-pane .job-operations-column.timing {
  text-align: right;
}
.pane.jobs-pane .job-timing-detailed-tile {
  display: table;
  float: right;
  font-size: 0.8rem;
  margin-right: -0.5rem;
  width: 13rem;
}
.pane.jobs-pane .job-timing-detailed-tile .job-timestamp-display {
  display: table-row;
}
.pane.jobs-pane .job-timing-detailed-tile .data-label, .pane.jobs-pane .job-timing-detailed-tile .timestamp-display {
  display: table-cell;
  padding: 0 0.5rem;
  white-space: nowrap;
}
.pane.jobs-pane .job-timing-detailed-tile .data-label {
  text-align: right;
  width: 8rem;
}
.pane.jobs-pane .jobs-columns-headers {
  border-bottom: var(--border-elevated);
  color: var(--color-base-text);
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: subgrid;
  margin-bottom: -0.35rem;
}
.pane.jobs-pane .jobs-columns-headers .job-name-header {
  padding-left: 3.5rem;
}
.pane.jobs-pane .jobs-columns-headers .job-last-status-header {
  padding-right: 1rem;
  text-align: right;
}
.pane.jobs-pane .jobs-list {
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: subgrid;
  margin-top: 0.35rem;
}
.pane.jobs-pane .job-creator {
  white-space: nowrap;
}
.pane.jobs-pane .jobs-item, .pane.jobs-pane .job-card, .pane.jobs-pane .job-summary {
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: subgrid;
}
.pane.jobs-pane .list .item.jobs-item {
  margin: 0;
  padding: 0;
}
.pane.jobs-pane .jobs-item:has(.job-selected-toggle:disabled) {
  opacity: 0.5;
}
.pane.jobs-pane .job-summary {
  cursor: default;
  padding: 0.3rem 1rem;
  -webkit-user-select: none;
  user-select: none;
}
.pane.jobs-pane .summary-column {
  white-space: nowrap;
  overflow: hidden;
}
.pane.jobs-pane .job-name-text {
  font-size: 0.9rem;
  overflow-x: hidden;
  text-overflow: ellipsis;
}
.pane.jobs-pane .job-details {
  grid-template-columns: subgrid;
  display: grid;
  grid-column: 1/-1;
  column-gap: 2rem;
  padding: 1rem 1rem 1rem 3.5rem;
}
.pane.jobs-pane .job-history-tile {
  font-size: 0.8rem;
  text-align: right;
}
.pane.jobs-pane .job-history-tile .job-history-tile {
  display: inline-block;
}
.pane.jobs-pane .job-history-tile .history-action {
  text-align: left;
}
.pane.jobs-pane .cancel-many {
  border-bottom: var(--border-elevated);
  padding: 0.8rem;
  margin: 0;
}
.pane.jobs-pane .cancel-many-action.cancel-selected, .pane.jobs-pane .cancel-many-action.confirm-cancel-selected {
  margin-left: 3rem;
  width: 11rem;
  white-space: nowrap;
}
.pane.jobs-pane .cancel-many-action {
  margin: 0;
}
.pane.jobs-pane .card-open .job-summary {
  background-color: var(--color-selected-canvas);
}
.pane.jobs-pane .job-detail-column.ids {
  text-align: right;
}
.pane.jobs-pane .job-name-display {
  display: inline;
  margin: 0 0 0 0.5rem;
  max-width: calc(100vw - 60rem);
  overflow-x: hidden;
  padding: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pane.jobs-pane .job-name-text, .pane.jobs-pane .job-timing-tile, .pane.jobs-pane .job-last-status-display {
  -webkit-user-select: text;
  user-select: text;
  white-space: nowrap;
}
.pane.jobs-pane .job-type-display:after {
  content: "-";
  margin: 0 0.6rem;
}
.pane.jobs-pane .job-last-status-display {
  color: var(--color-base-text);
  text-align: right;
}
.pane.jobs-pane .job-selected-toggle {
  margin: 0;
  position: relative;
  top: -0.1rem;
}
.pane.jobs-pane button.select-all, .pane.jobs-pane button.select-none {
  margin-left: 1rem;
}
.pane.jobs-pane .job-detail-column.history {
  display: table;
}
.pane.jobs-pane .job-history-entry {
  display: table-row;
}
.pane.jobs-pane .history-timestamp, .pane.jobs-pane .history-action, .pane.jobs-pane .history-message {
  display: table-cell;
  white-space: nowrap;
  padding: 0 0.5rem;
  border: var(--border-elevated);
}
.pane.jobs-pane .history-message {
  font-size: 0.7rem;
  text-align: left;
}
.pane.jobs-pane .history-action {
  min-width: 9rem;
}
.pane.jobs-pane .job-tags-display {
  max-width: 15rem;
}
.pane.jobs-pane .job-tag {
  background-color: var(--color-selected-canvas);
  display: inline-block;
  line-height: var(--font-size);
  margin-right: 0.7rem;
  padding: 0.5rem 1rem;
  white-space: nowrap;
}
.pane.jobs-pane .job-ids-tile {
  margin-top: -0.2rem;
}
.pane.jobs-pane .job-ids-tile .data-label, .pane.jobs-pane .job-ids-tile .id-text {
  color: var(--color-elevated-text);
}
.pane.jobs-pane .job-error-id .data-label, .pane.jobs-pane .job-error-id .id-text {
  color: var(--color-hinting-error);
  transition: all 1500ms ease-out;
}
.pane.jobs-pane .job-error-id .copied .id-text {
  color: var(--color-elevated-success);
  transition: all 100ms linear;
}
.pane.jobs-pane .icon.expand, .pane.jobs-pane .icon.collapse {
  margin: 0;
  padding: 0.5rem;
  fill: var(--color-base-draw);
  stroke: var(--color-base-draw);
}
.pane.jobs-pane .icon.collapse {
  fill: var(--color-elevated-draw);
  stroke: var(--color-elevated-draw);
}
.pane.jobs-pane .jobs-limit-current.search-occluded .limit {
  color: var(--color-elevated-warn);
}
.pane.jobs-pane .jobs-limit-actions {
  display: flex; /* defines flexbox */
  flex-direction: column-reverse;
  text-align: center;
  margin-top: 1rem;
  flex-grow: 1;
  color: var(--color-base-text);
}
.pane.jobs-pane .jobs-limit-action {
  color: var(--color-base-text);
  margin: 1rem;
}
.pane.jobs-pane .job-card.azure .job-last-status-display .data-label {
  color: var(--color-hinting-azure-base);
}
.pane.jobs-pane .job-card.azure .job-name-display, .pane.jobs-pane .job-card.azure .job-target, .pane.jobs-pane .job-card.azure .job-timing-tile, .pane.jobs-pane .job-card.azure .job-last-status-display .data-value {
  color: var(--color-hinting-azure-elevated);
}
.pane.jobs-pane .job-card.executing .job-name-display, .pane.jobs-pane .job-card.executing .job-summary .job-creator, .pane.jobs-pane .job-card.executing .job-target, .pane.jobs-pane .job-card.executing .job-timing-tile, .pane.jobs-pane .job-card.executing .job-last-status-display .data-label, .pane.jobs-pane .job-card.executing .job-last-status-display .data-value {
  color: var(--color-hinting-executing);
}
.pane.jobs-pane .job-card.completed:not(.card-open) .job-name-display, .pane.jobs-pane .job-card.completed:not(.card-open) .job-summary .job-creator, .pane.jobs-pane .job-card.completed:not(.card-open) .job-target, .pane.jobs-pane .job-card.completed:not(.card-open) .job-timing-tile, .pane.jobs-pane .job-card.completed:not(.card-open) .job-last-status-display .data-label, .pane.jobs-pane .job-card.completed:not(.card-open) .job-last-status-display .data-value {
  color: var(--color-hinting-completed);
}
.pane.jobs-pane .job-card.error:not(.card-open) .job-name-display, .pane.jobs-pane .job-card.error:not(.card-open) .job-summary .job-creator, .pane.jobs-pane .job-card.error:not(.card-open) .job-target, .pane.jobs-pane .job-card.error:not(.card-open) .job-timing-tile, .pane.jobs-pane .job-card.error:not(.card-open) .job-last-status-display .data-label, .pane.jobs-pane .job-card.error:not(.card-open) .job-last-status-display .data-value, .pane.jobs-pane .job-card.error.card-open .job-name-display, .pane.jobs-pane .job-card.error.card-open .job-summary .job-creator, .pane.jobs-pane .job-card.error.card-open .job-target, .pane.jobs-pane .job-card.error.card-open .job-timing-tile, .pane.jobs-pane .job-card.error.card-open .job-last-status-display .data-label, .pane.jobs-pane .job-card.error.card-open .job-last-status-display .data-value {
  color: var(--color-hinting-error);
}
.pane.jobs-pane .job-card.old:not(.card-open) .job-name-display, .pane.jobs-pane .job-card.old:not(.card-open) .job-summary .job-creator, .pane.jobs-pane .job-card.old:not(.card-open) .job-target, .pane.jobs-pane .job-card.old:not(.card-open) .job-timing-tile, .pane.jobs-pane .job-card.old:not(.card-open) .job-last-status-display .data-label, .pane.jobs-pane .job-card.old:not(.card-open) .job-last-status-display .data-value {
  color: var(--color-hinting-old);
}
.pane.jobs-pane .job-card.old.error:not(.card-open) .job-name-display, .pane.jobs-pane .job-card.old.error:not(.card-open) .job-summary .job-creator, .pane.jobs-pane .job-card.old.error:not(.card-open) .job-target, .pane.jobs-pane .job-card.old.error:not(.card-open) .job-timing-tile, .pane.jobs-pane .job-card.old.error:not(.card-open) .job-last-status-display .data-label, .pane.jobs-pane .job-card.old.error:not(.card-open) .job-last-status-display .data-value {
  color: var(--color-hinting-error-old);
}

.navigation-menu-closed .pane.jobs-pane .job-name {
  max-width: calc(100vw - 45rem);
}

.search-reminder {
  color: var(--color-elevated-success);
  min-width: 3rem;
  border-bottom: var(--border-width) solid var(--color-elevated-border);
  margin-top: 0.5rem;
  padding: 0 0.8rem 0.5rem 1.5rem;
  position: relative;
}
.search-reminder.empty {
  color: var(--color-elevated-warn);
}
.search-reminder .search-reminder-copy {
  font-size: 1rem;
}
.search-reminder .search-reminder-clear-button {
  margin-left: 3rem;
}

.errors.list {
  color: var(--color-elevated-warn);
}

.toggle-selection.checkbox {
  margin-left: 0.7rem;
}

.job-actions-tile {
  margin-top: 1.5rem;
  white-space: nowrap;
}

.job-action {
  margin-left: 1rem;
  fill: var(--color-elevated-draw);
}
.job-action .button-text {
  margin-left: 0.3rem;
}
.job-action.download.log {
  width: 5.5rem;
}
.job-action.download.result {
  width: 6rem;
}
.job-action.terminate {
  float: left;
  margin-left: 0;
  margin-right: 2rem;
  width: 7rem;
}
.job-action:first-of-type {
  margin-left: 0;
}

.navigation-menu-closed .pane.jobs-pane .jobs-list {
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/style/panes/jobs.scss"],"names":[],"mappings":"AACE;EACE,SAAA;EAAW,OAAA;AACf;AAOA;EACE,0BAAA;AALF;AAOE;EACE,kBAAA;EAAoB,UAAA;EAAY,WAAA;AAHpC;AAME;EACE,WAAA;AAJJ;AAOE;EACE,mBAAA;EACA,mCAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AALJ;AAQE;EACE,sDAAA;EACA,8BAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,0BAAA;EACA,yBAAA;EACA,aAAA;AANJ;AASE;EACE,aAAA;AAPJ;AAUI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,8CAAA;EACA,4CAAA;EACA,kBAAA;AARN;AAYE;EACE,kBAAA;EACA,kBAAA;EAAoB,SAAA;EAAW,YAAA;EAC/B,WAAA;AARJ;AAUE;EACE,kBAAA;EAAoB,SAAA;EAAW,YAAA;EAC/B,YAAA;AANJ;AASE;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,gNAAA;AAPJ;AAqBE;EACE,cAAA;AAnBJ;AAsBE;EACE,aAAA;EACA,2BAAA;EACA,2DACE;EAKF,gBAAA;AAzBJ;AA4BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AA1BJ;AA6BE;EACE,gEACE;AA5BN;AAkCI;EACE,mBAAA;AAhCN;AAqCE;EACE,mBAAA;AAnCJ;AAqCE;EACE,iBAAA;AAnCJ;AAsCE;EACE,cAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;AApCJ;AAsCI;EACE,kBAAA;AApCN;AAsCI;EACE,mBAAA;EACA,iBAAA;EACA,mBAAA;AApCN;AAsCI;EACE,iBAAA;EACA,WAAA;AApCN;AAwCE;EACE,qCAAA;EACA,6BAAA;EACA,aAAA;EACA,iBAAA;EACA,8BAAA;EACA,uBAAA;AAtCJ;AAwCI;EACE,oBAAA;AAtCN;AAwCI;EACE,mBAAA;EACA,iBAAA;AAtCN;AAyCE;EACE,aAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;AAvCJ;AA0CE;EACE,mBAAA;AAxCJ;AA2CE;EACE,aAAA;EACA,iBAAA;EACA,8BAAA;AAzCJ;AA4CE;EACE,SAAA;EACA,UAAA;AA1CJ;AA6CE;EACE,YAAA;AA3CJ;AA8CE;EACE,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;AA5CJ;AA+CE;EACE,mBAAA;EACA,gBAAA;AA7CJ;AA+CE;EACE,iBAAA;EACA,kBAAA;EACA,uBAAA;AA7CJ;AAgDE;EACE,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;AA9CJ;AAgDE;EACE,iBAAA;EACA,iBAAA;AA9CJ;AA+CI;EACE,qBAAA;AA7CN;AA+CI;EACE,gBAAA;AA7CN;AAgDE;EACE,qCAAA;EACA,eAAA;EACA,SAAA;AA9CJ;AAgDE;EACE,iBAAA;EACA,YAAA;EACA,mBAAA;AA9CJ;AAiDE;EACE,SAAA;AA/CJ;AAkDE;EACE,8CAAA;AAhDJ;AAmDE;EACE,iBAAA;AAjDJ;AAoDE;EACE,eAAA;EACA,oBAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;AAlDJ;AAqDE;EACE,yBAAA;EACA,iBAAA;EACA,mBAAA;AAnDJ;AAsDE;EACE,YAAA;EACA,gBAAA;AApDJ;AAuDE;EACE,6BAAA;EACA,iBAAA;AArDJ;AAwDE;EACE,SAAA;EACA,kBAAA;EAAoB,YAAA;AArDxB;AAwDE;EACE,iBAAA;AAtDJ;AAyDE;EACE,cAAA;AAvDJ;AAyDE;EACE,kBAAA;AAvDJ;AAyDE;EACE,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,8BAAA;AAvDJ;AA0DE;EACE,iBAAA;EACA,gBAAA;AAxDJ;AA2DE;EACE,eAAA;AAzDJ;AA4DE;EAEE,gBAAA;AA3DJ;AA6DE;EACE,8CAAA;EACA,qBAAA;EACA,6BAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;AA3DJ;AA8DE;EACE,mBAAA;AA5DJ;AA6DI;EACE,iCAAA;AA3DN;AA+DI;EACE,iCAAA;EACA,+BAAA;AA7DN;AA+DI;EACE,oCAAA;EACA,4BAAA;AA7DN;AAiEE;EAEE,SAAA;EACA,eAAA;EACA,4BAAA;EACA,8BAAA;AAhEJ;AAkEE;EACE,gCAAA;EACA,kCAAA;AAhEJ;AAmEE;EACE,iCAAA;AAjEJ;AAoEE;EACE,aAAA,EAAA,oBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,6BAAA;AAlEJ;AAqEE;EACE,6BAAA;EACA,YAAA;AAnEJ;AAuEI;EACE,sCAAA;AArEN;AAuEI;EACE,0CAAA;AArEN;AA0EI;EACE,qCAAA;AAxEN;AA6EI;EACE,qCAAA;AA3EN;AAgFI;EACE,iCAAA;AA9EN;AAmFI;EACE,+BAAA;AAjFN;AAsFI;EACE,qCAAA;AApFN;;AAgHA;EACE,8BAAA;AA7GF;;AAmJE;EACE,oCAAA;EACA,eAAA;EAEA,qEAAA;EACA,kBAAA;EACA,+BAAA;EAEA,kBAAA;AAlJJ;AAmJI;EACE,iCAAA;AAjJN;AAoJI;EACE,eAAA;AAlJN;AAqJI;EACE,iBAAA;AAnJN;;AAuJE;EACE,iCAAA;AApJJ;;AAsNE;EACE,mBAAA;AAnNJ;;AAsNE;EACE,kBAAA;EACA,mBAAA;AAnNJ;;AAqNE;EACE,iBAAA;EACA,gCAAA;AAlNJ;AAmNI;EACE,mBAAA;AAjNN;AAoNI;EACE,aAAA;AAlNN;AAqNI;EACE,WAAA;AAnNN;AAsNI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AApNN;AAuNI;EACE,cAAA;AArNN;;AA0NE;EACE,aAAA;AAvNJ","sourcesContent":[".navigation-menu-closed .pane.jobs-pane {\n  .new-job-backdrop {\n    top: 7rem; left: 0;\n  }\n  .new-job-editor-area {\n    // margin-left: -13rem;\n    // width: calc(100%);\n  }\n}\n\n.pane.jobs-pane {\n  width: calc(100vw - 14rem);\n\n  .show-new-job-toggle {\n    position: relative; top: -3rem; left: 17rem;\n  }\n\n  .action-bar:has(.cancel-many :checked) .show-new-job-toggle {\n    left: 45rem;\n  }\n\n  .new-job-backdrop {\n    align-items: center;\n    -webkit-backdrop-filter: blur(10px);\n    backdrop-filter: blur(10px);\n    display: flex;\n    justify-content: center;\n    position: fixed;\n    top: 4rem;\n    right: 0;\n    bottom: 0;\n    left: 13rem;\n    z-index: 999;\n  }\n\n  .new-job-editor-area {\n    background-color: var(--color-base-canvas-translucent);\n    border: var(--border-elevated);\n    color: var(--color-elevated-text);\n    line-height: 1.3rem;\n    margin-top: -6rem;\n    margin-left: -3rem;\n    padding: 0;\n    text-align: right;\n    height: calc(100% - 16rem);\n    width: calc(100% - 14rem);\n    z-index: 1000;\n  }\n\n  .new-job-container.hidden {\n    display: none;\n  }\n  .new-job-container {\n    .error-display {\n      position: absolute;\n      top: 60%;\n      left: 50%;\n      margin-left: -10rem;\n      width: 20rem;\n      z-index: 2000;\n      background-color: var(--color-elevated-canvas);\n      border: 1px solid var(--color-elevated-warn);\n      padding: 1rem 2rem;\n    }\n  }\n\n  .new-job-cancel {\n    margin-right: 3rem;\n    position: relative; top: 1rem; right: -3rem;\n    width: 4rem;\n  }\n  .new-job-submit {\n    position: relative; top: 1rem; right: -3rem;\n    width: 12rem;\n  }\n\n  .new-job-editor {\n    height: 100%;\n    width: 100%;\n    line-height: 1.7rem;\n    margin: 0;\n    padding: 1.5rem;\n    font-size: 1rem;\n    font-family: ui-monospace,\n      Menlo, Monaco,\n      \"Cascadia Mono\", \"Segoe UI Mono\",\n      \"Roboto Mono\",\n      \"Oxygen Mono\",\n      \"Ubuntu Mono\",\n      \"Source Code Pro\",\n      \"Fira Mono\",\n      \"Droid Sans Mono\",\n      \"Consolas\", \"Courier New\", monospace;\n  }\n\n\n\n  .cancel-many, .jobs-list, .search-reminder {\n    flex-shrink: 1;\n  }\n\n  .jobs-grid {\n    display: grid;\n    grid-auto-rows: max-content;\n    grid-template-columns:\n      minmax(15rem, auto)\n      9rem\n      17rem\n      17rem\n    ;\n    column-gap: 2rem;\n  }\n\n  .job-details-column.operations {\n    display: grid;\n    grid-column: span 3;\n    grid-template-columns: subgrid;\n  }\n\n  .jobs-grid.show-creator-in-summary {\n    grid-template-columns:\n      minmax(15rem, auto)\n      9rem\n      9rem\n      17rem\n      17rem\n    ;\n    .job-details-column.main-action {\n      grid-column: span 2\n    }\n  }\n\n\n  .job-operations-column.history {\n    grid-column: span 2;\n  }\n  .job-operations-column.timing {\n    text-align: right;\n  }\n\n  .job-timing-detailed-tile {\n    display: table;\n    float: right;\n    font-size: 0.8rem;\n    margin-right: -0.5rem;\n    width: 13rem;\n\n    .job-timestamp-display {\n      display: table-row;\n    }\n    .data-label, .timestamp-display {\n      display: table-cell;\n      padding: 0 0.5rem;\n      white-space: nowrap;\n    }\n    .data-label {\n      text-align: right;\n      width: 8rem;\n    }\n  }\n\n  .jobs-columns-headers {\n    border-bottom: var(--border-elevated);\n    color: var(--color-base-text);\n    display: grid;\n    grid-column: 1 / -1;\n    grid-template-columns: subgrid;\n    margin-bottom: -0.35rem;\n\n    .job-name-header {\n      padding-left: 3.5rem;\n    }\n    .job-last-status-header {\n      padding-right: 1rem;\n      text-align: right;\n    }\n  }\n  .jobs-list {\n    display: grid;\n    grid-column: 1 / -1;\n    grid-template-columns: subgrid;\n    margin-top: 0.35rem;\n  }\n\n  .job-creator {\n    white-space: nowrap;\n  }\n\n  .jobs-item, .job-card, .job-summary {\n    display: grid;\n    grid-column: 1 / -1;\n    grid-template-columns: subgrid;\n  }\n\n  .list .item.jobs-item {\n    margin: 0;\n    padding: 0;\n  }\n\n  .jobs-item:has(.job-selected-toggle:disabled) {\n    opacity: 0.5\n  }\n\n  .job-summary {\n    cursor: default;\n    padding: 0.3rem 1rem;\n    -webkit-user-select: none;\n    user-select: none;\n  }\n\n  .summary-column {\n    white-space: nowrap;\n    overflow: hidden;\n  }\n  .job-name-text {\n    font-size: 0.9rem;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .job-details {\n    grid-template-columns: subgrid;\n    display: grid;\n    grid-column: 1/-1;\n    column-gap: 2rem;\n    padding: 1rem 1rem 1rem 3.5rem;\n  }\n  .job-history-tile {\n    font-size: 0.8rem;\n    text-align: right;\n    .job-history-tile {\n      display: inline-block;\n    }\n    .history-action {\n      text-align: left;\n    }\n  }\n  .cancel-many {\n    border-bottom: var(--border-elevated);\n    padding: 0.8rem;\n    margin: 0;\n  }\n  .cancel-many-action.cancel-selected, .cancel-many-action.confirm-cancel-selected {\n    margin-left: 3rem;\n    width: 11rem;\n    white-space: nowrap;\n  }\n\n  .cancel-many-action {\n    margin: 0;\n  }\n\n  .card-open .job-summary {\n    background-color: var(--color-selected-canvas);\n  }\n\n  .job-detail-column.ids {\n    text-align: right;\n  }\n\n  .job-name-display {\n    display: inline;\n    margin: 0 0 0 0.5rem;\n    max-width: calc(100vw - 60rem);\n    overflow-x: hidden;\n    padding: 0;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .job-name-text, .job-timing-tile, .job-last-status-display {\n    -webkit-user-select: text;\n    user-select: text;\n    white-space: nowrap;\n  }\n\n  .job-type-display:after {\n    content: \"-\";\n    margin: 0 0.6rem;\n  }\n\n  .job-last-status-display {\n    color: var(--color-base-text);\n    text-align: right;\n  }\n\n  .job-selected-toggle {\n    margin: 0;\n    position: relative; top: -0.1rem;\n  }\n\n  button.select-all, button.select-none{\n    margin-left: 1rem;\n  }\n\n  .job-detail-column.history {\n    display: table;\n  }\n  .job-history-entry {\n    display: table-row;\n  }\n  .history-timestamp, .history-action, .history-message {\n    display: table-cell;\n    white-space: nowrap;\n    padding: 0 0.5rem;\n    border: var(--border-elevated);\n  }\n\n  .history-message {\n    font-size: 0.7rem;\n    text-align: left;\n  }\n\n  .history-action {\n    min-width: 9rem;\n  }\n\n  .job-tags-display {\n    // white-space: normal;\n    max-width: 15rem;\n  }\n  .job-tag {\n    background-color: var(--color-selected-canvas);\n    display: inline-block;\n    line-height: var(--font-size);\n    margin-right: 0.7rem;\n    padding: 0.5rem 1rem;\n    white-space: nowrap;\n  }\n\n  .job-ids-tile {\n    margin-top: -0.2rem;\n    .data-label, .id-text {\n      color: var(--color-elevated-text);\n    }\n  }\n  .job-error-id {\n    .data-label, .id-text {\n      color: var(--color-hinting-error);\n      transition: all 1500ms ease-out;\n    }\n    .copied .id-text {\n      color: var(--color-elevated-success);\n      transition: all 100ms linear;\n    }\n  }\n\n  .icon.expand, .icon.collapse {\n    // margin: 0 0.5rem 0 0;\n    margin: 0;\n    padding: 0.5rem;\n    fill: var(--color-base-draw);\n    stroke: var(--color-base-draw);\n  }\n  .icon.collapse {\n    fill: var(--color-elevated-draw);\n    stroke: var(--color-elevated-draw);\n  }\n\n  .jobs-limit-current.search-occluded .limit {\n    color: var(--color-elevated-warn);\n  }\n\n  .jobs-limit-actions {\n    display: flex;                   /* defines flexbox */\n    flex-direction: column-reverse;\n    text-align: center;\n    margin-top: 1rem;\n    flex-grow: 1;\n    color: var(--color-base-text);\n  }\n\n  .jobs-limit-action {\n    color: var(--color-base-text);\n    margin: 1rem;\n  }\n\n  .job-card.azure {\n    .job-last-status-display .data-label {\n      color: var(--color-hinting-azure-base);\n    }\n    .job-name-display, .job-target, .job-timing-tile, .job-last-status-display .data-value {\n      color: var(--color-hinting-azure-elevated);\n    }\n  }\n\n  .job-card.executing {\n    .job-name-display, .job-summary .job-creator, .job-target, .job-timing-tile, .job-last-status-display .data-label, .job-last-status-display .data-value {\n      color: var(--color-hinting-executing);\n    }\n  }\n\n  .job-card.completed:not(.card-open) {\n    .job-name-display, .job-summary .job-creator, .job-target, .job-timing-tile, .job-last-status-display .data-label, .job-last-status-display .data-value {\n      color: var(--color-hinting-completed);\n    }\n  }\n\n  .job-card.error:not(.card-open), .job-card.error.card-open {\n    .job-name-display, .job-summary .job-creator, .job-target, .job-timing-tile, .job-last-status-display .data-label, .job-last-status-display .data-value {\n      color: var(--color-hinting-error);\n    }\n  }\n\n  .job-card.old:not(.card-open) {\n    .job-name-display, .job-summary .job-creator, .job-target, .job-timing-tile, .job-last-status-display .data-label, .job-last-status-display .data-value {\n      color: var(--color-hinting-old);\n    }\n  }\n\n  .job-card.old.error:not(.card-open) {\n    .job-name-display, .job-summary .job-creator, .job-target, .job-timing-tile, .job-last-status-display .data-label, .job-last-status-display .data-value {\n      color: var(--color-hinting-error-old);\n    }\n  }\n\n  // .job-card.azure {\n  //   color: var(--color-microsoft-azure);\n  //   .job-name, .data-label, .data-value {\n  //     color: var(--color-microsoft-azure);\n  //   }\n  // }\n\n  // .job-card:has(.error) {\n  //   color: var(--color-elevated-warn);\n  //   .job-name, .data-label, .data-value {\n  //     color: var(--color-elevated-warn);\n  //   }\n  // }\n\n  // .job-card:has(.executing) {\n  //   color: var(--color-elevated-success);\n  //   .job-name, .data-label, .data-value {\n  //     color: var(--color-elevated-success);\n  //   }\n  // }\n\n\n}\n\n.navigation-menu-closed .pane.jobs-pane .job-name {\n  max-width: calc(100vw - 45rem);\n}\n\n//   .job-type {\n//     color: var(--color-base-text);\n//     margin-right: 0.5rem;\n//   }\n//   // .job-type:after {\n//   //   content: \"-\";\n//   //   margin: 0 1rem;\n//   // }\n\n//   .job-summary {\n\n//   }\n\n//   .job-summary-content {\n//     grid-column: span 3;\n//     display: grid;\n//     grid-template-columns: subgrid;\n//     line-height: 2rem;\n//     font-size: var(--font-size-card-title);\n\n//     .job-title, .job-queue-display, .display-job-duration {\n//       padding: 0;\n//       margin: 0 2rem 0 0;\n//       display: inline-block;\n//     }\n//   }\n\n//   .job-card[open] .job-summary {\n//     color: var(--color-base-text);\n\n//     .job-title, .job-queue-display, .job-received-at, .display-job-duration, .job-status-detail-display {\n//       display: block;\n//     }\n//   }\n\n  .search-reminder {\n    color: var(--color-elevated-success);\n    min-width: 3rem;\n    // max-width: 45rem;\n    border-bottom: var(--border-width) solid var(--color-elevated-border);\n    margin-top: 0.5rem;\n    padding: 0 0.8rem 0.5rem 1.5rem;\n\n    position: relative;\n    &.empty {\n      color: var(--color-elevated-warn);\n    }\n\n    .search-reminder-copy {\n      font-size: 1rem;\n    }\n\n    .search-reminder-clear-button {\n      margin-left: 3rem;\n    }\n  }\n\n  .errors.list {\n    color: var(--color-elevated-warn);\n  }\n\n//   .job-card.exited.old {\n//     // opacity: var(--opacity-inactive);\n\n//     &:hover {\n//       opacity: 1;\n//     }\n//   }\n\n//   .job-card.error {\n//     .job-status-detail-display, .job-status-detail-display .data-label {\n//       color: var(--color-elevated-warn);\n//     }\n//   }\n\n//   .error-id {\n//     color: var(--color-elevated-warn);\n//   }\n\n//   .job-status-detail-display {\n//     .data-label {\n//       text-transform: capitalize;\n//     }\n//   }\n\n//   .job-status-display, .job-status-timestamp {\n//     margin-left: 0.5rem;\n//   }\n\n//   .job-status-display {\n//     display: none;\n//   }\n\n//   .copy-job-metadata {\n//     display: none;\n//   }\n\n//   .job-aqumen-id, .job-external-id, .job-error-id {\n//     clear: both;\n//     margin-left: 1rem;\n//     float: right;\n//   }\n\n//   .control-server {\n//     &.unavailable, &.locked, &.reservation-conflict {\n//       color: var(--color-elevated-warn);\n//     }\n//   }\n\n//   .exited .control-server {\n//     &.unavailable, &.locked, &.reservation-conflict {\n//       color: var(--color-elevated-draw);\n//     }\n//   }\n\n//   .job-actions {\n//     margin-top: 1rem;\n//     text-align: right;\n//   }\n\n  // .cancel-many:has(.jobs-preferences-container.open) .toggle-selection {\n  //   display: none;\n  // }\n\n  .toggle-selection.checkbox {\n    margin-left: 0.7rem;\n  }\n\n  .job-actions-tile {\n    margin-top: 1.5rem;\n    white-space: nowrap;\n  }\n  .job-action {\n    margin-left: 1rem;\n    fill: var(--color-elevated-draw);\n    .button-text {\n      margin-left: 0.3rem;\n    }\n\n    &.download.log {\n      width: 5.5rem;\n    }\n\n    &.download.result {\n      width: 6rem;\n    }\n\n    &.terminate {\n      float: left;\n      margin-left: 0;\n      margin-right: 2rem;\n      width: 7rem;\n    }\n\n    &:first-of-type {\n      margin-left: 0;\n    }\n  }\n\n.navigation-menu-closed .pane.jobs-pane {\n  .jobs-list {\n    margin-top: 0;\n  }\n}\n\n// }\n\n// @media only screen and (min-width: 1000px) {\n//   :not(.navigation-menu-closed) {\n//     .jobs-pane {\n//       .jobs-item .job-actions {\n//         margin-top: -2.15rem;\n//         position: absolute; right: 1rem;\n//         width: 25rem;\n\n//         .job-action {\n//           float: unset;\n//         }\n//       }\n//     }\n//   }\n// }\n// @media only screen and (min-width: 800px) {\n//   .navigation-menu-closed {\n//     .jobs-pane {\n//       .jobs-item .job-actions {\n//         margin-top: -2.15rem;\n//         position: absolute; right: 1rem;\n//         width: 25rem;\n//         .job-action {\n//           float: unset;\n//         }\n//       }\n//     }\n//   }\n// }\n\n// @media only screen and (max-width: 600px) {\n//   .jobs-pane {\n//     grid-template-columns: unset;\n\n//     .job-id {\n//       display: block;\n//       margin-left: 0;\n//     }\n\n//     .job-actions {\n//       width: unset !important;\n//     }\n\n//     .job-action {\n//       width: calc(100vw - 6rem) !important;\n//       margin: 1rem 0 !important;\n//       display: block;\n//       white-space: unset;\n\n//       &.copy-job-metadata {\n//         display: none;\n//       }\n//     }\n//   }\n// }\n\n// .chrome {\n//   .jobs-pane {\n//     .job-aqumen-id, .job-external-id, .job-error-id {\n//       margin-top: -0.3rem;\n//     }\n//   }\n// }\n\n// .chrome.windows {\n//   .jobs-pane {\n//     .job-aqumen-id, .job-external-id, .job-error-id {\n//       margin-top: -0.5rem;\n//     }\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
